import React, { Component } from 'react';
import {
  Divider,
  Switch,
  Button,
  NumericInput,
  FormGroup,
} from '@blueprintjs/core';
import SideMenuWrapper from '../Components/SideMenuWrapper';

export default class FortressWar extends Component {
  constructor(...args) {
    super(...args);

    this.state = {
      ConstantinePulleys: false,
      BerserkMode: false,
      BerserkPotions: false,
      Trace: false,
      KillCounterWindow: false,
      UsingPets: false,
      PCLimit: false,
      PCLimitCount: '',
    };

    this.handleChange = (Name) => (Value) => {
      if (typeof this.state[Name] === 'boolean')
        this.setState({ [Name]: !this.state[Name] });
      else if (Value.target) this.setState({ [Name]: Value.target.value });
      else this.setState({ [Name]: Value });
    };
  }

  render() {
    const SwitchOnOff = { innerLabelChecked: 'on', innerLabel: 'off' };

    return (
      <SideMenuWrapper>
        <h3
          className="display-4 font-italic mb-4"
          style={{ fontSize: '1.5rem' }}
        >
          FTW Fortress War
        </h3>

        <Divider />

        <table className="bp3-html-table bp3-html-table-bordered bp3-interactive html-table-row-border">
          <tbody>
            <tr>
              <td style={{ minWidth: '240px' }}>Constantine Pulleys</td>
              <td>
                <Switch
                  checked={this.state.ConstantinePulleys}
                  {...SwitchOnOff}
                  onChange={this.handleChange('ConstantinePulleys')}
                />
              </td>
            </tr>

            <tr>
              <td>
                <FormGroup helperText="in Fortress War" className="mb-0">
                  Berserk Mode
                </FormGroup>
              </td>
              <td>
                <Switch
                  checked={this.state.BerserkMode}
                  {...SwitchOnOff}
                  onChange={this.handleChange('BerserkMode')}
                />
              </td>
            </tr>

            <tr>
              <td>
                <FormGroup helperText="in Fortress War" className="mb-0">
                  Berserk Potions
                </FormGroup>
              </td>
              <td>
                <Switch
                  disabled={!this.state.BerserkMode}
                  checked={this.state.BerserkPotions}
                  {...SwitchOnOff}
                  onChange={this.handleChange('BerserkPotions')}
                />
              </td>
            </tr>

            <tr>
              <td>
                <FormGroup helperText="in Fortress War" className="mb-0">
                  Trace
                </FormGroup>
              </td>
              <td>
                <Switch
                  checked={this.state.Trace}
                  {...SwitchOnOff}
                  onChange={this.handleChange('Trace')}
                />
              </td>
            </tr>

            <tr>
              <td>Kill Counter Window</td>
              <td>
                <Switch
                  checked={this.state.KillCounterWindow}
                  {...SwitchOnOff}
                  onChange={this.handleChange('KillCounterWindow')}
                />
              </td>
            </tr>

            <tr>
              <td>
                <FormGroup helperText="in Fortress War" className="mb-0">
                  Using Pick or Attack Pets
                </FormGroup>
              </td>
              <td>
                <Switch
                  checked={this.state.UsingPets}
                  {...SwitchOnOff}
                  onChange={this.handleChange('UsingPets')}
                />
              </td>
            </tr>

            <tr>
              <td>
                <FormGroup helperText="in Fortress War" className="mb-0">
                  PC Limit
                </FormGroup>
              </td>
              <td>
                <Switch
                  checked={this.state.PCLimit}
                  {...SwitchOnOff}
                  onChange={this.handleChange('PCLimit')}
                />
              </td>
            </tr>

            <tr>
              <td>
                <FormGroup helperText="in Fortress War" className="mb-0">
                  PC Limit Count
                </FormGroup>
              </td>
              <td style={{ width: '240px' }}>
                <NumericInput
                  disabled={!this.state.PCLimit}
                  style={{ width: '190px' }}
                  value={this.state.PCLimitCount}
                  placeholder="Type a number..."
                  onValueChange={this.handleChange('PCLimitCount')}
                  min={0}
                  className="mb-4"
                />
              </td>
            </tr>

            <tr>
              <td></td>
              <td>
                <Button className="mt-2" icon="floppy-disk" text="Save" />
              </td>
            </tr>
          </tbody>
        </table>
      </SideMenuWrapper>
    );
  }
}
